import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {CancelOfferLoanOrderStates} from "./types/CancelOfferLoanOrderTypes";
import withAuth from "../../hoc/withAuth";
import {Alert, Button, Card, Col, Collapse, Form, Input, Modal, Row, Select} from "antd";
import Cookies from "universal-cookie";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import {loanService} from "../../services/otodisApi/LoanService";
import {InfoCircleOutlined} from "@ant-design/icons";

const {Panel} = Collapse;

export interface CancelOfferProps {
}

class CancelOfferLoanOrder extends Component<CancelOfferProps & any, CancelOfferLoanOrderStates> {
    private readonly initState!: CancelOfferLoanOrderStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private token = new Cookies().get('_t');
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: CancelOfferProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            companyCode: companyCode,
            offerCode: "",
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
            listCancelCategory: [""],
            loanData: {},
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value,
            offerCode: "",
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
            listCancelCategory: [""]
        });
    }

    getDataOffer = async () => {
        if (!this.state.offerCode) {
            return Modal.error({title: 'Proses Gagal', content: 'Lengkapi data'});
        }
        const offerCodes = this.state.offerCode.split(",");
        if (offerCodes.length > 1) {
            await this.defaultState();
            return Modal.error({title: 'Proses Gagal', content: "batch cancel offer loan dibatasi 1 offer"});
        }

        await this.promisedSetState({fetchProcess: true});

        let loanResult = {};
        await loanService.setToken(this.token);
        try {
            const getLoanResult = await loanService.getLoanBpkb({branch_code: this.state.dealerCode, loan_code: this.state.offerCode});
            loanResult = getLoanResult.data.data[0];

        } catch (e) {
            this.setState({fetchProcess: false});
            return Modal.error({title: 'Proses Gagal', content: e?.toString()});
        }

        await this.promisedSetState({
            fetchProcess: false,
            cancelReason: null,
            cancelCategory: null,
            showFormCancel: true,
            cancelProcess: false,
            loanData: loanResult
        });
    }

    cancelOffer = async () => {
        if (!this.state.cancelCategory || !this.state.cancelReason) {
            return Modal.error({title: 'Proses Gagal', content: 'Mohon Lengkapi inputan'});
        }
        await this.promisedSetState({cancelOfferModal: true})
    }

    triggerCancelOffer = async () => {
        const dataCancel = {
            update_type: "cancel-order-offer",
            company: this.state.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.loanData.offer_code,
            cancel_category: this.state.cancelCategory,
            cancel_reason: this.state.cancelReason,
        }
        await this.promisedSetState({cancelProcess: true});
        try {
            await offerGeneralApiService.updateOffer(dataCancel);
            Modal.success({title: 'Proses Sukses', content: 'Offer & Order Loan berhasil di cancel'});
            await this.defaultState();
        } catch (e) {
            await this.promisedSetState({cancelProcess: false});
            return Modal.error({title: 'Proses Gagal', content: e?.toString()});
        }
    }

    defaultState = async () => {
        await this.promisedSetState({
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
            listCancelCategory: [""]
        });
    }

    onFieldChange = <T extends keyof Pick<any, "offerCode" | "cancelReason" | "cancelCategory" | "fineInvoice">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "offerCode":
                currentState.offerCode = value;
                break;
            case "cancelReason":
                currentState.cancelReason = value;
                break;
            case "cancelCategory":
                currentState.cancelCategory = value;
                break;
            case "fineInvoice":
                currentState.fineInvoice = value;
                break;
        }

        let a = [""];
        if (target === "cancelCategory") {
            if (value === "TEST") {
                a = ["TEST DEVELOPER"];
            }
            if (value === "DEALER") {
                a = ["DUPLICATE PO", "INDENT TERLALU LAMA", "WARNA TIDAK SESUAI", "DP TIDAK SIAP", "GAGAL BAST", "GAGAL PELUNASAN", "CLOSING DENGAN SPK LAIN", "SALAH INPUT DATA", "PEMESAN NO RESPOND"];
            }
            if (value === "FINCO") {
                a = ["PENGAJUAN KREDIT DITOLAK", "TIDAK JADI KREDIT KENDARAAN", "PO PINDAH KE DEALER LAIN", "GAGAL BAST", "GAGAL PELUNASAN"];
            }
            if (value === "CUSTOMER") {
                a = ["TIDAK JADI BELI KENDARAAN", "MEMBELI DARI DEALER LAIN", "MEMBELI DARI MARKETING LAIN", "MEMBELI MERK LAIN", "INDENT TERLALU LAMA", "TIDAK ADA PROMO YANG COCOK", "WARNA TIDAK SESUAI", "MEMILIH TIPE LAIN", "GANTI WARNA", "GANTI MODEL/TIPE"];
            }
            currentState.listCancelCategory = a;
            currentState.cancelReason = null;
        }

        this.setState({
            ...currentState,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Cancel Offer & Order Loan`} defaultSelectedKeys={['m-cancel-loan-order']} defaultOpenKeys={['sm-sm-sys-offer', 'sm-offer']}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <div style={{padding: 20}}>
                        <Row>
                            <Col xs={24} xl={12}>
                                <Card title="Cancel Offer & Order Loan" style={{margin: 10}}>
                                    <Collapse ghost>
                                        <Panel header={<span> <InfoCircleOutlined style={{color: "#1890ff"}}/> <i>Aturan Cancel Offer & Order Loan ... </i></span>} key="1">
                                            <Alert
                                                message="Cancel Offer & Order Loan"
                                                description={<div>
                                                    <ul>
                                                        <li><i>offer dan cancel akan merubah status offer dan order menjadi cancel</i></li>
                                                    </ul>
                                                </div>}
                                                type="info"
                                                showIcon
                                                style={{marginBottom: 10}}
                                            />
                                        </Panel>
                                    </Collapse>
                                    <br/>
                                    <Form layout="vertical">
                                        <Form.Item>
                                            Kode Order Loan
                                            <Input value={this.state.offerCode} disabled={this.state.showFormCancel} placeholder="Kode Order Loan" onChange={event => this.onFieldChange("offerCode", event.target.value)}/>
                                        </Form.Item>
                                        <span style={!this.state.showFormCancel ? {display: 'none'} : {}}>
                                            <br/>
                                            <Form.Item>
                                                <div className={`text-small-grey`}>Kategori Alasan</div>
                                                <Select placeholder="Kategori Alasan" showSearch optionFilterProp="children" onChange={value => this.onFieldChange("cancelCategory", value)} value={this.state.cancelCategory}>
                                                    <Select.Option key={`DEALER`} value={`DEALER`}>{`DEALER`}</Select.Option>
                                                    <Select.Option key={`FINCO`} value={`FINCO`}>{`FINCO`}</Select.Option>
                                                    <Select.Option key={`CUSTOMER`} value={`CUSTOMER`}>{`CUSTOMER`}</Select.Option>
                                                    <Select.Option key={`TEST`} value={`TEST`}>{`TEST`}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item>
                                                <div className={`text-small-grey`}>Kategori Alasan</div>
                                                <Select placeholder="Alasan Cancel" showSearch optionFilterProp="children" onChange={value => this.onFieldChange("cancelReason", value)} value={this.state.cancelReason}>
                                                    {this.state.listCancelCategory.map((item: any, i: number) =>
                                                        <Select.Option key={i} value={item}>{item}</Select.Option>
                                                    )}
                                                </Select>
                                            </Form.Item>
                                            <br/>
                                            <Button type={"default"} onClick={() => this.defaultState()}> Batalkan Proses Cancel</Button>
                                            &nbsp; &nbsp;
                                            <Button type={"primary"} danger={true} loading={this.state.cancelProcess} onClick={() => this.cancelOffer()}> Lakukan Cancel Offer & Order Loan</Button>
                                        </span>
                                        <span style={this.state.showFormCancel ? {display: 'none'} : {}}>
                                            <br/>
                                            <Button type={"primary"} loading={this.state.fetchProcess} onClick={() => this.getDataOffer()}> Get Data Order Loan</Button>
                                        </span>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal
                        open={this.state.cancelOfferModal}
                        title="Konfirmasi CANCEL OFFER LOAN ORDER"
                        onCancel={() => this.setState({cancelOfferModal: false})}
                        cancelText={'Tutup'} okText={false}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button type={"primary"} loading={this.state.cancelProcess} key="1" onClick={this.triggerCancelOffer}>Cancel Offer & Order Loan</Button>,
                            <Button loading={this.state.cancelProcess} key="2" onClick={() => this.setState({cancelOfferModal: false})}>Close</Button>,
                        ]}
                    >
                        Anda Yakin Akan Malakukan <b>cancel</b> offer Loan Order ? <br/><br/>
                    </Modal>

                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(CancelOfferLoanOrder), 68));